import React from "react";
import {
  useReactTable,
  getCoreRowModel,
  flexRender,
  createColumnHelper,
} from "@tanstack/react-table";

const columnHelper = createColumnHelper();

// Converts reason names into safe keys for object access
const getSafeKey = (reason) => reason.replace(/[^a-zA-Z0-9]/g, "_");

// Red shade generator for background
const getRedShadeWithOpacity = (value, max) => {
  const normalized = Math.min(value / max, 1);
  const lightness = 90 - normalized * 50;
  const opacity = 0.7;
  return `hsla(0, 100%, ${lightness}%, ${opacity})`;
};

const TanStackTable = ({
  data,
  columns,
  accountName,
  reasonKeyMap,
  maxPerReason,
}) => {
  const table = useReactTable({
    data,
    columns,
    getCoreRowModel: getCoreRowModel(),
  });

  return (
    <div style={{ padding: "10px", overflowX: "auto" }}>
      {data && data.length > 0 ? (
        <>
          <p className="text-sm mb-2">
            <span className="font-medium">Account Name: {accountName}</span>
          </p>
          <table
            style={{
              borderCollapse: "collapse",
              fontSize: "12px",
              tableLayout: "auto",
            }}
          >
            <thead>
              {table.getHeaderGroups().map((headerGroup) => (
                <tr key={headerGroup.id}>
                  {headerGroup.headers.map((header) => (
                    <th
                      key={header.id}
                      style={{
                        border: "1.5px solid #d1d5db",
                        backgroundColor: "#F3F4F8",
                        textAlign: "center",
                        padding: "6px",
                        fontSize: "11px",
                      }}
                    >
                      {flexRender(
                        header.column.columnDef.header,
                        header.getContext()
                      )}
                    </th>
                  ))}
                </tr>
              ))}
            </thead>
            <tbody>
              {table.getRowModel().rows.map((row) => (
                <tr key={row.id}>
                  {row.getVisibleCells().map((cell) => {
                    const originalReason = reasonKeyMap[cell.column.id];
                    return (
                      <td
                        key={cell.id}
                        style={{
                          fontWeight:
                            cell.column.id === "month" ? "bold" : "normal",
                          padding: "6px",
                          border: "1.5px solid #d1d5db",
                          textAlign: "center",
                          fontSize: "11px",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          backgroundColor:
                            typeof cell.getValue() === "number" &&
                              maxPerReason[originalReason]
                              ? getRedShadeWithOpacity(
                                cell.getValue(),
                                maxPerReason[originalReason]
                              )
                              : "transparent",
                        }}
                      >
                        {cell.getValue()}
                      </td>
                    );
                  })}
                </tr>
              ))}
            </tbody>
          </table>
        </>
      ) : (
        <div className="text-center text-red-400 text-sm">
          No Data Available For this ARN
        </div>
      )}
    </div>
  );
};

export default TanStackTable;